'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _utils = require('../utils');

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KeyFeatures = function KeyFeatures(el) {
  var _this = this;

  (0, _classCallCheck3.default)(this, KeyFeatures);

  this.els = {
    el: el,
    cardTitles: (0, _functional.getElements)('.prd-KeyFeatures_CardTitle', { context: el })
  };

  var adjustTitleHeights = function adjustTitleHeights() {
    // Remove any already-existing height values
    _this.els.cardTitles.forEach(function (element) {
      return element.style.removeProperty('height');
    });

    // Calc the tallest title
    var maxHeight = _this.els.cardTitles.reduce(function (maxHeight, current) {
      return Math.max(maxHeight, current.offsetHeight);
    }, -Infinity);

    // Apply to all
    _this.els.cardTitles.forEach(function (element) {
      element.style.height = maxHeight + 'px';
    });
  };

  window.addEventListener('resize', (0, _utils.debounce)(adjustTitleHeights, 50));
  adjustTitleHeights();
};

exports.default = KeyFeatures;